/* eslint-disable max-len */
export const getOptionsLists = (state) =>
	state.optionsLists.optionsLists && state.optionsLists.optionsLists.data;
export const getOptionsListsPending = (state) => state.optionsLists.pending;
